import { ArrowBackIcon } from '../../../../Icons'
import { Section } from '../../../../Sections'
import * as QRCode from 'qrcode'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { ApplicationState } from '../../../../../store'
import { QRSectionProps } from './interfaces'
import Styles from './QRSection.module.css'
import { APIRequest } from '../../../../../api'
import i18next from 'i18next'
import { loginWithTokens } from '../../../../../store/profile'
import { useThunkDispatch } from '../../../../../hooks/useThunkDispatch'
import { Logger } from '../../../../../modules'
import { useSuccessLoginNavigation } from '../../hooks/useSuccessLoginNavigation'

function getQrUrl(baseUrl: string, qrCode: string): string {
	return `${baseUrl}/auth/login?remote=true&qrCode=${qrCode}`
}

export const QRSection = ({ navigate: navigateSection, context: { privacyChecked } }: QRSectionProps): React.ReactElement => {
	const [qrCode, setQrCode] = useState<string>('')
	const [qrCodeUrl, setQRCodeUrl] = useState<string>('/assets/icons/loading-animation.gif')
	const { config: configState } = useSelector((state: ApplicationState) => state)
	const { API_WS_SERVER, LYNXCLOUD_CLIENT } = configState
	const dispatchThunk = useThunkDispatch()

	const navigateAfterQRCodeAuth = useSuccessLoginNavigation({ privacyChecked })

	useEffect(() => {
		const mount = async (): Promise<void> => {
			const ws = new WebSocket(`${API_WS_SERVER}/auth/qr`)

			let qrLoaded = false
			let qrCodeUrl = ''
			ws.onmessage = async (msg): Promise<void> => {
				const { code: codeId, success, accessToken } = JSON.parse(msg.data)
				qrCodeUrl = getQrUrl(LYNXCLOUD_CLIENT, codeId)

				if (codeId) {
					setQrCode(codeId)
					QRCode.toDataURL(qrCodeUrl, (error, qrCode) => {
						setQRCodeUrl(qrCode)
						qrLoaded = true
					})
				}

				if (success) {
					await APIRequest.setAuthorization(accessToken)
					const tokens = await APIRequest.User.createSession(null, { withCredentials: true })
					await dispatchThunk(loginWithTokens(tokens))
					navigateAfterQRCodeAuth()
				}
			}
			setTimeout(() => {
				if (!qrLoaded) {
					QRCode.toDataURL(qrCodeUrl, (error, qrCode) => {
						setQRCodeUrl(qrCode)
						qrLoaded = true
					})
				}
			}, 3000)
		}
		mount()
	}, [])

	const handleBack = (): void => {
		navigateSection('SignInSection')
	}

	const handleQRCodeClick = async (): Promise<void> => {
		if (!navigator.clipboard) {
			return
		}

		try {
			await navigator.clipboard.writeText(getQrUrl(LYNXCLOUD_CLIENT, qrCode))
		} catch (err) {
			Logger.error('Failed to copy QR Code to Clipboard', err)
		}
	}

	return (
		<Section
			side="right"
			title={
				<div className={Styles['title-container']}>
					<div className={Styles['back-arrow']} onClick={handleBack}>
						<ArrowBackIcon />
					</div>
					<div>{i18next.t('pages.login.qrSignin')}</div>
				</div>
			}
			className={Styles['qr-section']}
		>
			<img src={qrCodeUrl} alt="QR Code" onClick={handleQRCodeClick} />
			<p className={Styles['qr-text']}>{i18next.t('pages.login.qrCodeText')}</p>
		</Section>
	)
}
